// extracted by mini-css-extract-plugin
export default {"headerWrapper":"styles_headerWrapper__KQoXb","container":"styles_container__UpgUj","coffeeImage":"styles_coffeeImage__x+E-a"};